export enum FlaggersMethods {
  UpdateFlagger = 'UpdateFlagger',
  ResetFlagger = 'ResetFlagger',
}
